import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { tokens, Text, Button } from '@hotjar/hotsauce';

const Title = styled(Text)`
  display: flex;
  margin-bottom: ${tokens.spacer.x4};
`;

const Video = styled.video`
  width: 100%;
  border: 1px solid ${tokens.color.ui_border_light};
  margin-bottom: ${tokens.spacer.x4};
`;

const HowToFixHeader = styled(Text)`
  margin-top: ${tokens.spacer.x3};
  margin-bottom: ${tokens.spacer.x2pt5};
`;

const RetakerButton = styled(Button)`
  margin-top: ${tokens.spacer.x4};
  justify-content: center;
`;

interface SupportSecondaryViewProps {
  titleText: string;
  videoPath: string;
  description: React.ReactNode;
  howToFix: React.ReactNode;
  onTakeNewScreenshotClick: () => void;
}

export const SupportSecondaryView = ({
  titleText,
  videoPath,
  description,
  howToFix,
  onTakeNewScreenshotClick,
}: SupportSecondaryViewProps): JSX.Element => {
  const { t } = useTranslation('heatmaps');
  return (
    <>
      <Title textType="subtitle1">{titleText}</Title>
      <Video data-testid="hm-support-video" src={videoPath} autoPlay loop />
      {description}
      <HowToFixHeader textType="subtitle2">{t('smart-panel.support.how-to-fix')}</HowToFixHeader>
      {howToFix}
      <RetakerButton onClick={onTakeNewScreenshotClick}>
        {t('smart-panel.support.take-new-screenshot')}
      </RetakerButton>
    </>
  );
};
